import { useState } from "react";
import { token } from "@/lib/api";
import { UserRound } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function photoSrc(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${BACKEND}${url}${sep}auth=${token() || ""}`;
}

export function Avatar({ photos, name, className = "", size = 48, fill = false }) {
  const [err, setErr] = useState(false);
  const primary = (photos || []).find((p) => p.primary) || (photos || [])[0];
  const src = primary ? photoSrc(primary.url) : null;
  // "fill" mode (or very large size) => size via className (w-full h-full), not oversized inline px
  const isFill = fill || size >= 400;
  const dims = isFill ? {} : { width: size, height: size };
  const iconStyle = isFill ? { width: "40%", height: "40%" } : { width: size * 0.5, height: size * 0.5 };
  if (src && !err) {
    return (
      <img src={src} onError={() => setErr(true)} alt={name || "Profile"}
        className={`object-cover ${className}`} style={dims} loading="lazy" />
    );
  }
  return (
    <div className={`flex items-center justify-center bg-[#FAF3E0] text-[#C59B27] ${className}`} style={dims}>
      <UserRound style={iconStyle} />
    </div>
  );
}
